/*
    Block List Page
*/

import { BlockListContainer as BlockList } from "./BlockList.container";

export default BlockList;
